import { render, staticRenderFns } from "./fund-aside.vue?vue&type=template&id=cfe028f6&"
var script = {}
import style0 from "../../../assets/styles/panels/_Banner.scss?vue&type=style&index=0&lang=scss&"
import style1 from "../../../assets/styles/panels/_SidePanel.scss?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports